export default "__VITE_ASSET__9cNtkJyz__"